module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ch2",
      "title": "Why Does Traffic Jam for No Apparent Reason?"
    }
  }, [_c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rch2"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("Why Does Traffic Jam for No Apparent Reason?")])])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "193",
      "src": "images/f009.jpg",
      "width": "313"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Everyone has experienced the frustration of a “phantom traffic jam.” The traffic just seems to stop for no apparent reason, and by the time you’re moving freely again, you cannot see what might have caused it—there is no accident, no roadwork, no police interference. So, why do these jams happen?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If there are enough cars on a highway, any minor disruptions to the flow of traffic can trigger a chain reaction. All it takes is for one car to brake unexpectedly. A driver might get too close to the car in front, look at the scenery and lose concentration, change lanes in front of another car, or slow because of a bump in the road. The driver then brakes slightly, forcing the unsuspecting drivers behind to react with their own brakes so they can stay at a safe distance. A ripple effect occurs and the braking amplifies backward. It’s like a shock wave that becomes more pronounced as it works its way back until a traffic jam is produced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A phantom traffic jam will take longer to dissipate than it takes to develop, and as you drive forward, the effects of the jam move backward. The front of the jam clears, and by the time the cars at the back are moving freely again, the road in front is almost empty and drivers are left wondering what the problem was in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A 2008 experiment conducted by Professor Yuki Sugiyama, the head of the Mathematical Society of Traffic Flow at Japan’s Nagoya University, had 22 cars drive on a circular road. A phantom traffic jam was soon created, the cars piling up in under a minute. The study showed that the solution to the problem is all about speed and spacing. When people drive a little slower and keep a bigger space between themselves and the car in front, the snowballing effect of sudden braking is avoided and fewer traffic jams occur.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7f6d6f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter002.vue
// module id = 75
// module chunks = 0